import * as type from '../../types';

const initialState = {
  response: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  loading: false,
  error: null
};


export default function adminAllLeadsReducer(state = initialState, action) {
  switch (action.type) {

    case type.FETCH_ADMIN_ALL_LEADS:
      return {
        ...state,
        loading: true,
        error: null
      };

    // case type.FETCH_ADMIN_ALL_LEADS_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     response: action.payload,
    //     error: null
    //   };
    case type.FETCH_ADMIN_ALL_LEADS_SUCCESS:
        console.log(
    "🟣 REDUCER PAYLOAD PAGINATION:",
    action.payload.pagination
  );
  return {
    ...state,
    loading: false,
    response: action.payload.data || [],     //  leads array
    pagination: action.payload.pagination || {}, //  pagination meta
    error: null,
  };


    case type.FETCH_ADMIN_ALL_LEADS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.message
      };

      case type.UPDATE_LEAD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_LEAD_SUCCESS:
  return {
    ...state,
    response: state.response.map((lead) =>
      lead._id === action.payload._id
        ? {
            ...lead,
            subcategory: {
              ...lead.subcategory,
              label: action.payload.subcategory,
            },
          }
        : lead
    ),
  };

case type.UPDATE_LEAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
const initialGraphState = {
  graphData: [],
  loading: false,
  error: null,
};

export function graphReducer(state = initialGraphState, action) {
  switch (action.type) {

    case type.FETCH_GRAPH:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case type.FETCH_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        graphData: action.payload,
        error: null,
      };

    case type.FETCH_GRAPH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
